import React from 'react'
import PropTypes from 'prop-types'
import ProductCard from "./product-card";
import './we-recommended.scss'

const GALLERY_ID = "RECOMMENDED_GALLERY"

export default class WeRecommended extends React.Component {
  render() {
    const recommended = this.props.recommended;
    return (
      <div className="we-rec">
        <h3 className="we-rec__title">I recommend:</h3>
        <div className="we-rec__wrapper">
          <div className="we-rec__item-list">
            <amp-carousel id={GALLERY_ID}
              height="500"
              layout="fixed-height"
              type="carousel">
              {recommended.map((product) => (
                <div key={product.product_name} className="we-rec__item">
                  <ProductCard {...product} />
                </div>
              ))}
            </amp-carousel>
          </div>
        </div>
      </div>
    )
  }
}


WeRecommended.propTypes = {
  recommended: PropTypes.any.isRequired
}





// WEBPACK FOOTER //
// ./src/components/we-recommended/we-recommended.js